module.exports = {
	"ha": "viha",
	"id": 5.7,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by HSDA, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -140,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.6510067114094,
						"dataLabels": {
							"enabled": true,
							"format": "291"
						}
					},
					{
						"y": 90.26845637583892,
						"dataLabels": {
							"enabled": true,
							"format": "269"
						}
					},
					{
						"y": 87.58389261744966,
						"dataLabels": {
							"enabled": true,
							"format": "261"
						}
					},
					{
						"y": 82.5503355704698,
						"dataLabels": {
							"enabled": true,
							"format": "246"
						}
					},
					{
						"y": 67.11409395973155,
						"dataLabels": {
							"enabled": true,
							"format": "200"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.45762711864407,
						"dataLabels": {
							"enabled": true,
							"format": "115"
						}
					},
					{
						"y": 90.67796610169492,
						"dataLabels": {
							"enabled": true,
							"format": "107"
						}
					},
					{
						"y": 88.13559322033898,
						"dataLabels": {
							"enabled": true,
							"format": "104"
						}
					},
					{
						"y": 76.27118644067797,
						"dataLabels": {
							"enabled": true,
							"format": "90"
						}
					},
					{
						"y": 61.86440677966102,
						"dataLabels": {
							"enabled": true,
							"format": "73"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.08454810495627,
						"dataLabels": {
							"enabled": true,
							"format": "666"
						}
					},
					{
						"y": 84.6938775510204,
						"dataLabels": {
							"enabled": true,
							"format": "581"
						}
					},
					{
						"y": 80.466472303207,
						"dataLabels": {
							"enabled": true,
							"format": "552"
						}
					},
					{
						"y": 74.19825072886297,
						"dataLabels": {
							"enabled": true,
							"format": "509"
						}
					},
					{
						"y": 54.22740524781341,
						"dataLabels": {
							"enabled": true,
							"format": "372"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.348993288590606,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.560137457044669,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.9739776951672847,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.747126436781613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.699186991869922,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.5423728813559365,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.956521739130439,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.8037383177570097,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.461538461538458,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.88888888888889,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.9154518950437303,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.762762762762758,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.991394148020656,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.789855072463769,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.915520628683698,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Central Vancouver Island<br>n=298"
			},
			{
				"x": 9,
				"text": "North Vancouver Island<br>n=118"
			},
			{
				"x": 15,
				"text": "South Vancouver Island<br>n=686"
			}
		],
		"dataTable": {
			"Central Vancouver Island": [
				298,
				291,
				269,
				261,
				246,
				200
			],
			"North Vancouver Island": [
				118,
				115,
				107,
				104,
				90,
				73
			],
			"South Vancouver Island": [
				686,
				666,
				581,
				552,
				509,
				372
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_7.json
// module id = 335
// module chunks = 0